import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

const getHeaderTitle = () => {
    const location = window.location.href;
    
    const roundList = useSelector(state => state.rounds);
    const currentRound = roundList.byId[roundList.currentRoundId];

    const title = 'CYA Helper - ';

    if (location.indexOf('landing-page') > -1) {
        return title + 'Welcome';
    } else if (location.indexOf('add-players') > -1) {
        return title + 'Add Players';
    } else if (location.indexOf('round-details') > -1) {
        if (currentRound) {
            return title + `Round ${currentRound.index + 1}`;
        }
        return 'CYA Helper';
    } else if (location.indexOf('complete') > -1) {
        return title + 'Game Complete';
    }

    return title + 'Welcome';
}

const titleCreatorComponent = props => (
    <React.Fragment>
        <Toolbar className={'title'} style={{color: 'white'}}>{getHeaderTitle()}</Toolbar>
    </React.Fragment>
);

export default withRouter(titleCreatorComponent)